import isNull from "./NullChecking";
import store from "../store";
export const FindParrent = ( parrent) => {
    const state = store.getState();
    let RolesMenu = [] 
    if(!isNull(state.RolesandRightsReducer)){
        RolesMenu = state.RolesandRightsReducer
    }
    if (RolesMenu.length > 0) {
        let ParentItem
        ParentItem = RolesMenu && RolesMenu.filter(item => item.MenuName === parrent)
        if (ParentItem) {
            return {
                ISView: ParentItem[0]?.ISView,
                IsAdd: ParentItem[0]?.IsAdd,
                IsDeleted: ParentItem[0]?.IsDeleted,
            }
        }else{
            return {
                ISView: false,
                IsAdd: false,
                IsDeleted: false,
            }
        }
    }else{
        return {
            ISView: false,
            IsAdd: false,
            IsDeleted: false,
        }
    }
}
export const FindFirstChild = (parrent, child1) => {
    const state = store.getState();
    let RolesMenu = [] 
    if(!isNull(state.RolesandRightsReducer)){
        RolesMenu = state.RolesandRightsReducer
    }
    if (RolesMenu.length > 0) {
        let ParentItem
        let Children1Item
        ParentItem = RolesMenu && RolesMenu.filter(item => item.MenuName === parrent)
        Children1Item = ParentItem && ParentItem[0]?.Children.filter(item => item.MenuName === child1)
        if (Children1Item) {
            return {
                ISView: Children1Item[0]?.ISView,
                IsAdd: Children1Item[0]?.IsAdd,
                IsDeleted: Children1Item[0]?.IsDeleted,
            }
        }else{
            return {
                ISView: false,
                IsAdd: false,
                IsDeleted: false,
            }
        }
    }else{
        return {
            ISView: false,
            IsAdd: false,
            IsDeleted: false,
        }
    }
}
export const FindSecondChild = (parrent, child1, child2) => {
    const state = store.getState();
    let RolesMenu = [] 
    if(!isNull(state.RolesandRightsReducer)){
        RolesMenu = state.RolesandRightsReducer
    }
    if (RolesMenu.length > 0) {
        let ParentItem
        let Children1Item
        let Children2Item
        ParentItem = RolesMenu && RolesMenu.filter(item => item.MenuName === parrent)
        Children1Item = ParentItem && ParentItem[0]?.Children.filter(item => item.MenuName === child1)
        Children2Item = Children1Item && Children1Item[0]?.Children.filter(item => item.MenuName === child2)
        if (Children2Item) {
            return {
                ISView: Children2Item[0]?.ISView,
                IsAdd: Children2Item[0]?.IsAdd,
                IsDeleted: Children2Item[0]?.IsDeleted,
            }
        }else{
            return {
                ISView: false,
                IsAdd: false,
                IsDeleted: false,
            }
        }
    }else{
        return {
            ISView: false,
            IsAdd: false,
            IsDeleted: false,
        }
    }
}